<template>
  <div>
    <!-- <a-button type="primary" @click="showModal">
      Open Modal
    </a-button> -->
    <a-modal
      v-model="visible"
      :title="null"
      @ok="handleOk"
      :maskClosable="false"
      :closable="false"
      :footer="null"
      class="modal-collection-form"
    >
      <div :style="{ height: modalHeight }">
        <iframe
          :src="iframeUrl"
          :style="{
            width: iframeWidth,
            height: iframeHeight,
            border: 'none',
          }"
          ref="contactFrame"
        ></iframe>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      modalHeight: "430px",
      iframeWidth: "100%",
      iframeHeight: "100%",
      lang: BX24.getLang(),
    };
  },
  computed: {
    iframeUrl() {
      return `https://local.app.support.pl/app-resource-library/data-collection-form/?lang=${
        this.lang
      }&q=${Date.now()}`;
    },
  },

  async mounted() {
    window.addEventListener("message", this.receiveMessage);
    setTimeout(() => BX24.fitWindow(), 2000);
    //  '.add-record'
    // ----------------------------
    const url =
      "https://local.app.support.pl/app-resource-library/data-collection-form/ajax/api.php";
    const res = await this.fetchData(".get-record", {domain: BX24.getDomain(), application:window.location.hostname, version: "v1" }, url);
    // console.log("mounted fetchData res: ", { res });

    if (!res.version) {
      this.showModal();
      this.getIframeSize();
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  },
  methods: {
    sendMessageToIframe() {
      const iframe = this.$refs.contactFrame;

      if (iframe) {
        // Отправляем сообщение в iframe, указываем домен родителя
        // iframe.contentWindow.postMessage({ action: "getOrigin", lang: this.lang }, "https://vat.app.support.pl");
        iframe.contentWindow.postMessage(
          {
            action: "getOrigin",
            lang: this.lang,
            domain: "https://vat.app.support.pl",
          },
          "https://local.app.support.pl"
        );
      } else {
        console.warn("Iframe не найден");
      }
    },

    async receiveMessage(event) {
      // console.log("Получено сообщение:", event);

      // Проверяем, что сообщение пришло от доверенного источника
      const allowedOrigins = ["https://local.app.support.pl"];
      if (!allowedOrigins.includes(event.origin)) {
        // console.warn("event.origin:", event.origin);
        // console.warn("Сообщение от недоверенного источника:", event.origin);
        return;
      }

      if (event?.data?.values) {
        // Обновляем данные в компоненте
        // this.dataUserCollection = event.data.values;
        const data = event.data.values;

        // ----------------------------
        const url =
          "https://local.app.support.pl/app-resource-library/data-collection-form/ajax/api.php";

        this.fetchData(
          ".add-record",
          { domain: BX24.getDomain(), application: window.location.hostname, version: "v1", ...data },
          url
        );
        // console.log("mounted fetchData res: ", { res });
        this.visible = false;
      }
    },

    // -------------------------
    showModal() {
      this.visible = true;
      setTimeout(() => this.sendMessageToIframe(), 1500);
    },
    handleOk() {
      // console.log(e);
      this.visible = false;
    },

    async fetchData(name, params = false, url = false) {
      if (!url)
        url =
          "https://local.app.support.pl/app-resource-library/data-collection-form/ajax/index.php";
      let data = {
        name: name, // Название файла без расширения
      };
      if (params) {
        data = { ...data, ...params };
      }
      let result = {};
      try {
        const response = await fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          throw new Error(`Ошибка: ${response.status}`);
        }

        result = await response.json();
      } catch (error) {
        console.error("Ошибка при запросе:", error);
      }

      return result;
    },

    async getIframeSize() {
      const res = await this.fetchData(".iframeSize");
      if (res && res.data) {
        // modalHeight: "430px",
        // iframeWidth: "100%",
        // iframeHeight: "100%",

        if (res.data.modalHeight) {
          setTimeout(() => {
            this.modalHeight = res.data.modalHeight;
          }, 1000);
        }

        if (res.data.iframeWidth) {
          setTimeout(() => {
            this.iframeWidth = res.data.iframeWidth;
          }, 1000);
        }

        if (res.data.iframeHeight) {
          setTimeout(() => {
            this.iframeHeight = res.data.iframeHeight;
          }, 1000);
        }
      }
    },
  },
};
</script>

<style>
.modal-collection-form .ant-modal-body {
  padding: 0;
}
</style>
